import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // optional, for styles or Tailwind
import "./style.css"
import MainRoute from './routes';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';

import store from "./redux/store";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <MainRoute />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);
